
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 7a3 3 0 100-6 3 3 0 000 6zM8.953 10H9.4c1.987 0 3.6 1.344 3.6 3v.929C13 14.52 12.424 15 11.714 15H2.286C1.576 15 1 14.52 1 13.929V13c0-1.656 1.612-3 3.6-3h.447A5.475 5.475 0 007 10.357c.696 0 1.358-.13 1.953-.357z","stroke":"#fff","stroke-opacity":".7","stroke-width":"2"}})])
          )
        }
      }
    